<script lang="ts">
  import { onMount } from "svelte";
  import { extractTitleFromContent } from "../../utils";
  
  export let content: string = "";
  
  // Extract title
  let contentTitle = extractTitleFromContent(content);
  
  // Function to improve image attributes
  onMount(() => {
    // Only run this in browser environment
    if (typeof document !== 'undefined') {
      const contentImages = document.querySelectorAll(
        "#content img",
      ) as NodeListOf<HTMLImageElement>;

      contentImages.forEach((img) => {
        img.loading = "lazy";
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "cover";
        img.style.objectPosition = "center";
        img.style.borderRadius = "8px";
        
        // If alt text is missing, provide a basic one
        if (!img.alt || img.alt === "") {
          img.alt = contentTitle ? `Image related to ${contentTitle}` : "Article image";
        }
      });
    }
  });
</script>

{#if content}
  <div id="content" class="content">
    {@html content}
  </div>
{/if}

<style lang="scss">
    .content {
        font-size: inherit;
        font-family: inherit;
        font-weight: inherit;
        color: inherit;
        letter-spacing: inherit;
        line-height: inherit;
        text-align: inherit;
    }
</style>